import styled from 'styled-components'
import theme from '../../styles/theme'

export const Wrapper = styled.div`
  .delete-modal {
    > p {
      text-align: center;
      font-size: ${theme.font.sizes.normal};
      font-family: ${theme.font.comfortaa};
      font-weight: ${theme.font.normal};
    }

    .attention-label {
      color: ${theme.colors.red};
      font-weight: ${theme.font.xbold};
    }

    > div {
      display: flex;
      margin-top: 24px;
      gap: 28px;
    }
  }
`
